import { Link } from "react-router-dom";
// import { useNavigate } from 'react-router-dom';
export const MobileCard = ({ task, IMAGE_PATH }) => {
    //newCode useNavigate
    // const navigate = useNavigate()
    
    
    let publishedDate = '';
    if(task && task.submitted_on !== undefined && task.submitted_on !== ''){
        // Convert UNIX timestamp to a JavaScript Date object
        let submittedDate = new Date(task.submitted_on * 1000);

        let day = submittedDate.getDate();
        let month = submittedDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();

        publishedDate = `${day} ${month}`;
    }

    let submittedDateFormatted = '';
    if (task && task.hasOwnProperty('last_submission_date_1')) {
        let Last_Submission_Date = task?.last_submission_date_1?.value?.[0];
        let submittedDate = new Date(Last_Submission_Date);

        // Extract day, month (in short form and uppercase), and year
        let day = submittedDate.getDate();
        let month = submittedDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        let year = submittedDate.getFullYear();

        // Format the date as "DD MON YYYY"
        submittedDateFormatted = `${day} ${month} ${year}`;
    }

    //New Code useNavigate
    // const handleNavigation  = (task) =>{
    //     navigate(`/collabwithgov/detail/${task.artifact_id}`, { state: { task } });
    // }

    return (
        <>
            <div className="card"  
            // new Code useNavigate
            // onClick={()=>handleNavigation(task)}
            //   style={{ cursor: "pointer" }}
              >
                {/* previous code  */}
                <Link to={`/collabwithgov/detail/${task.artifact_id}`}
                style={{ textDecoration: 'none', color: 'inherit' }}> 
                    <div className="badge">
                        {
                            (task.hasOwnProperty('category') && (task.category.value) && (task.category.value.length > 0))?task.category.value.slice(0,1).map((category, idx) => (
                                <span key={`category-${idx}`}>{category}</span>
                            )):''
                        }  
                    </div>
                    <div className="title">
                    {
                        (task.hasOwnProperty('title') && (task.title.value) && (task.title.value.length > 0))?task.title.value.map((title, idx) => (
                            <span key={`title-${idx}`}>{title}</span>
                        )):''
                    }  
                    </div>
                    <div className="date"><img src={`${IMAGE_PATH}/calendar_today.png`} style={{verticalAlign: 'bottom'}} alt="calendar_today.png"/> {publishedDate} - {submittedDateFormatted} </div>
                    <div className="complexity">Complexity Level: 
                        {
                            (task.hasOwnProperty('complexity') && (task.complexity.value) && (task.complexity.value.length > 0))?task.complexity.value.slice(0,1).map((level, idx) => (
                                <span key={`level-${idx}`}>{level}</span>
                            )):''
                        }  
                    </div>
                    <div className="tags">
                    {
                        (task.hasOwnProperty('skills_and_expertise') &&(task.skills_and_expertise.value) && (task.skills_and_expertise.value.length > 0))?task.skills_and_expertise.value.slice(0,1).map((skill, idx) => (
                            <div className="tag" key={`skill-${idx}`}>{skill}</div>
                        )):''
                    }  
                    </div>
                {/* previous code */}
                </Link>
            </div> 
        </>
    )
}
